import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {ProductDetail} from "./product-detail";

const ProductDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/products');
    }

    return (
        <ProductDetail id={id} onClose={onClose}/>
    )

});

export default ProductDetailPage;